module.exports = __webpack_public_path__ + "media/book-trailer.96d38e06.mp4";